import { useState } from "react";

export default function AdminBar({ onToggle, pageOne = false }) {
  const [hovered, setHovered] = useState(false);
  const isAdmin = window.location.pathname === "/admin";

  // Page One: quiet serif "browser chrome" — muted grey, small caps, letter-spaced,
  // no bright link color. Otherwise the original developer-console look.
  const grey = "rgb(150,145,135)";
  const font = pageOne ? "Georgia, 'Times New Roman', serif" : "monospace";
  const smallCaps = pageOne ? "small-caps" : "normal";
  const statusColor = pageOne ? grey : isAdmin ? "#ffcc33" : "#3399ff";
  const labelColor = pageOne ? grey : "#333";
  const dividerColor = pageOne ? "rgba(150,145,135,0.4)" : "#1e1e1e";
  const btnColor = pageOne ? grey : hovered ? "#ccc" : "#555";

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
      height: 36, background: "#050505", borderBottom: "1px solid #1a1a1a",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "0 20px", fontFamily: font, fontVariant: smallCaps,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: pageOne ? 11 : 9, letterSpacing: "0.2em", color: labelColor, textTransform: "uppercase" }}>
          Admin
        </span>
        <span style={{ color: dividerColor }}>|</span>
        <span style={{
          fontSize: pageOne ? 11 : 9, letterSpacing: "0.15em", textTransform: "uppercase",
          color: statusColor,
        }}>
          {isAdmin ? "● Editorial Control" : "● Subscriber View"}
        </span>
      </div>
      <button
        onClick={onToggle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          background: hovered && !pageOne ? "#111" : "none",
          border: `1px solid ${pageOne ? "rgba(150,145,135,0.35)" : hovered ? "#2a2a2a" : "#1a1a1a"}`,
          color: btnColor,
          padding: "3px 12px", borderRadius: 3, cursor: "pointer",
          fontSize: pageOne ? 11 : 10, fontFamily: font, fontVariant: smallCaps, letterSpacing: "0.08em",
          transition: "all 0.1s",
        }}>
        {isAdmin ? "→ Subscriber View" : "→ Editorial Control"}
      </button>
    </div>
  );
}
